import { date, number, object, string } from 'yup'

export const tournamentDateSchema = object({
  date: date().required(),
  timezoneType: number().required(),
  timezone: string().required(),
}).from('timezone_type', 'timezoneType')
